import { z } from "zod";

import {
  LATEST_LIFETIME_TERMS_VERSION,
  LATEST_PRIVACY_VERSION,
  LATEST_TOS_VERSION,
} from "./versions";

// HTML checkboxes send "on" when checked, omit the field when unchecked.
// `z.literal("on")` rejects both shapes with the same error message; the
// first-arg `error` covers Conform's coercion of missing form-data values
// to undefined (matches the auth schemas' pattern in lib/auth/schemas.ts).
//
// The hidden tos_version / privacy_version inputs let the server reject
// a stale-page submit (LATEST_* bumped between page render and submit).
// Without this, a user reading v1.0 text would have v1.1 acceptance
// recorded against text they never saw — defensible-at-trial issue for
// material-change bumps.
export const acceptLegalSchema = z.object({
  accept_tos: z.literal("on", {
    error: "You must agree to the Terms of Service to continue.",
  }),
  accept_privacy: z.literal("on", {
    error: "You must agree to the Privacy Policy to continue.",
  }),
  tos_version: z.literal(LATEST_TOS_VERSION, {
    error: "Terms of Service updated — please refresh and read the new version.",
  }),
  privacy_version: z.literal(LATEST_PRIVACY_VERSION, {
    error: "Privacy Policy updated — please refresh and read the new version.",
  }),
});

// Lifetime checkout only, not part of the legal gate; same stale-version defence as above.
export const acceptLifetimeTermsSchema = z.object({
  accept_lifetime_terms: z.literal("on", {
    error: "You must agree to the Lifetime & Guarantee Terms to continue.",
  }),
  lifetime_terms_version: z.literal(LATEST_LIFETIME_TERMS_VERSION, {
    error: "The Lifetime & Guarantee Terms were updated. Please refresh and read the new version.",
  }),
});
